import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
  testGreener = "lorem";

  constructor(SettingsService, DynamicPageService, Config) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.DynamicPageService = DynamicPageService;
    this.generalConfig = Config.getModuleConfig(Config.Modules.General);
    this.frontPageConfig = Config.getModuleConfig(Config.Modules.FrontPage);
  }

  $onInit() {
    this.name = this.generalConfig.getClientName();
    this.version = this.frontPageConfig.getFlavor();

    this.SettingsService.getPublicByName({name: 'frontpage-settings'}, config => {

      /* CLASSIC */
      this.textConfig = config.data.texts;
      this.showLogosFrontpage = config.data.showLogos;
      this.subHeading = config.data.subHeading;

      /* FULLSLIDER */
      this.injectionPoint = config.data.injection;
      this.injectionPointVideo = config.data.injectionVideo;
      this.slides = config.data.slides;

      /* VIDEO */
      if (this.version == "video") {
        this.video = config.data.videoUrl;
        this.poster = config.data.posterUrl;
      }

      this.containerClass = config.data.containerClass || 'container';

      if (this.version == "fullslider" || this.version == "video" || this.version == 'pageonly') {
        this.DynamicPageService.getPublicByName({name: "frontpage-content"}, page => {
          this.html = this.convertShortcode(page.data);
        }, err => {
        });
      }

      if (this.version == "classic") {
        jQuery("div.frontpage").css('background-image', 'url(' + config.data.background + ')');
      }
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }

  fadeInLeft($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated fadeInLeftBig'); // this example leverages animate.css classes
  }

  fadeInRight($el) {
    console.log('fadeInRight');
    $el.removeClass('not-visible');
    $el.addClass('animated fadeInRightBig'); // this example leverages animate.css classes
  }

  fadeInUp($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated fadeInUp'); // this example leverages animate.css classes
  }

  fadeInDown($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated fadeInDown'); // this example leverages animate.css classes
  }

  pulse($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated pulse'); // this example leverages animate.css classes
  }

  zoomIn($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated zoomIn'); // this example leverages animate.css classes
  }

  fadeIn($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated fadeIn'); // this example leverages animate.css classes
  }

  lightSpeedIn($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated lightSpeedIn'); // this example leverages animate.css classes
  }

  lightSpeedOut($el) {
    $el.removeClass('not-visible');
    $el.addClass('animated lightSpeedOut'); // this example leverages animate.css classes
  }

  resetAnimation($el) {
    $el.addClass("not-visible");
    $el.removeClass("animated fadeInLeftBig fadeInRightBig fadeInUp fadeInDown pulse zoomIn fadeIn lightSpeedIn lightSpeedOut")
  }

}

export default angular.module('conduuApp.mainView', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js